import { useTranslation } from 'react-i18next';
import styles from './index.module.less';
import { RecentDataType } from '..';

interface Props {
  onBackClick: () => void;
  searchData: RecentDataType;
  onTryAnotherFreeSearch: () => void;
  onFeedback: () => void;
  isShowBackButton?: boolean;
}

const FeedbackIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00065 10.0026C8.18954 10.0026 8.34798 9.9386 8.47598 9.8106C8.60398 9.6826 8.66776 9.52438 8.66732 9.33594C8.66687 9.14749 8.60287 8.98927 8.47532 8.86127C8.34776 8.73327 8.18954 8.66927 8.00065 8.66927C7.81176 8.66927 7.65354 8.73327 7.52598 8.86127C7.39843 8.98927 7.33443 9.14749 7.33398 9.33594C7.33354 9.52438 7.39754 9.68283 7.52598 9.81127C7.65443 9.93972 7.81265 10.0035 8.00065 10.0026ZM7.33398 7.33594H8.66732V3.33594H7.33398V7.33594ZM1.33398 14.6693V2.66927C1.33398 2.3026 1.46465 1.98883 1.72598 1.72794C1.98732 1.46705 2.3011 1.33638 2.66732 1.33594H13.334C13.7007 1.33594 14.0147 1.4666 14.276 1.72794C14.5373 1.98927 14.6678 2.30305 14.6673 2.66927V10.6693C14.6673 11.0359 14.5369 11.3499 14.276 11.6113C14.0151 11.8726 13.7011 12.003 13.334 12.0026H4.00065L1.33398 14.6693ZM3.43398 10.6693H13.334V2.66927H2.66732V11.4193L3.43398 10.6693Z"
      fill="#02183A"
    />
  </svg>
);

export default function NotFound({
  onBackClick,
  searchData,
  onTryAnotherFreeSearch,
  onFeedback,
  isShowBackButton = true,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {/* 返回按钮 */}
      {searchData?.type === 'premium' && isShowBackButton && (
        <div>
          <button className={styles.backButton} onClick={onBackClick}>
            <span>&lt; {t('Back')}</span>
          </button>
        </div>
      )}

      {/* 内容卡片 */}
      <div className={styles.card}>
        <h2 className={styles.title}>😞 {t('No Matches Found')}</h2>
        <p className={styles.description}>{t("We didn't find any matches for your search at this time.")}</p>
        {searchData?.type === 'premium' ? (
          <button className={styles.feedbackButton} onClick={onFeedback}>
            <FeedbackIcon />
            {t('Feedback')}
          </button>
        ) : (
          <button className={styles.tryButton} onClick={onTryAnotherFreeSearch}>
            👉 {t('Try Another Search')}
          </button>
        )}
      </div>
    </div>
  );
}
